import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProductBundleDetailsService } from './marketplaceBundleServices';
import { FetchProductBundleDetailsParams } from '../types';

// Fetch all product bundles
export const fetchProductBundleDetails = createAsyncThunk(
    'productBundle/fetchBundleDetails',
    async (
        params: FetchProductBundleDetailsParams,
        { rejectWithValue, getState, dispatch }
    ) => {
        try {
            // Explicitly type RootState or import it from your store definition
            const state = getState() as { marketplace: any };
            const marketplaceSelector = state.marketplace;
            const response = await getProductBundleDetailsService(params, marketplaceSelector, dispatch);
            // Assuming response.data contains the product bundle details
            // Adjust this based on your actual API response structure
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch product bundles');
        }
    }
);